    // Safari stellt Notification nur als PWA zur Verfügung. Deshalb behandeln wir das im Browser so, als hätte der Benutzer Notifications deaktiviert.
export function notificationPermission () { return('Notification' in window) ? Notification.permission : "denied" }
export function requestNotificationPermission (){ return Notification.requestPermission()}
export const serviceWorkerRegistration = navigator.serviceWorker ? navigator.serviceWorker.ready : undefined;
export function getSubscription (registration: ServiceWorkerRegistration) {return registration.pushManager.getSubscription()}

let urlBase64ToUint8Array = function (base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}

export function subscribe (registration: ServiceWorkerRegistration, vapidKey: string) {
    return registration
        .pushManager
        .subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(vapidKey)
        })
        .then((sub) => {
            return sub
        })
        .catch((err) => {console.error(err)});
}

export function mapSubscription (pushSubscription: PushSubscription) {
    return {
        Endpoint: pushSubscription.endpoint,
        P256DH: btoa(String.fromCharCode(...new Uint8Array(pushSubscription.getKey("p256dh")))),
        Auth: btoa(String.fromCharCode(...new Uint8Array(pushSubscription.getKey("auth"))))
    }
}
